/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import {
  Typography,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Modal,
  Fade,
  Backdrop,
  Link,
  Box,
  Button,
  TextField,
} from "@material-ui/core";
import store from "store2";
import Loader from "react-loader";
import { ThumbUp, ThumbDown } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

// components
import MainLayout from "../../components/hoc/MainLayout";
import DateFilter from "../../components/DateFilter";
import { apiGet } from "../../helpers/api";

import JSONToCSVConvertor from "../../helpers/JSONToCSVConvertor";
import { Pagination } from "@material-ui/lab";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
  table: { minWidth: 650 },
  noResults: { fontStyle: "italic", color: "#b99d9d" },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "400px",
  },
}));

function Transactions() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [data, setData] = useState(null);
  const [exportData, setExportData] = useState(null);
  const [stores, setStores] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [remarks, setRemarks] = useState("");
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [email, setEmail] = useState("");


  useEffect(() => {
  	const user = store.session.get("user");
    if (user) {
      setEmail(user.email);
    }
  }, []);

  const fetchData = useCallback(async () => {
    let start = moment(startDate).format("YYYY-MM-DD");
    let end = moment(endDate).format("YYYY-MM-DD");

    // get data from api
    try {
      let url = `/reports/deliveries/time_reports?page=${page}&date_from=${start}&date_to=${end}`;
      if (stores.length > 0) {
        url = `${url}&stores=${stores.join(",")}`;
      }
      setData(null);
      const response = await apiGet(url);
      setData(response.data);
    } catch (e) {
      console.log(e.response?.data?.message);
    }
  }, [startDate, endDate, stores, page]);

  const fetchExportData = async () => {
    let start = moment(startDate).format("YYYY-MM-DD");
    let end = moment(endDate).format("YYYY-MM-DD");

    try {
      let url = `/reports/deliveries/time_reports/export?date_from=${start}&date_to=${end}`;
      if (stores.length > 0) {
        url = `${url}&stores=${stores.join(",")}`;
      }
      url = `${url}&email=${email}`;
      const response = await apiGet(url);

      if (response.data.background) {
        enqueueSnackbar(response.data.message, {
          autoHideDuration: 10000,
        });
        return;
      }

      JSONToCSVConvertor(
        response.data.data,
        "transactions",
        response.data.headers
      );
    } catch (e) {
      console.log(e.response?.data?.message);
    }
  };

  const handlePaginationChange = (e, p) => {
    setPage(p);
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const renderRating = (rating) => {
    if (rating === 0) {
      return <>No Rating</>;
    }

    if (rating < 3) {
      return <ThumbDown />;
    }

    return <ThumbUp />;
  };

  console.log(email);

  return (
    <Loader loaded={data !== null}>
      <Typography variant="h5" gutterBottom>
        Transactions
      </Typography>

      <div style={{ display: "flex", alignItems: "center" }}>
        <DateFilter
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          filterAction={fetchData}
          storeChangeHandler={(e) => {
            setStores(e.target.value);
          }}
          stores={stores}
        />

        <Button
          onClick={() => fetchExportData()}
          style={{ marginLeft: 15 }}
          disabled={data?.rows.length === 0}
          variant="contained"
        >
          Download
        </Button>
        {endDate &&
        startDate &&
        moment.duration(moment(endDate).diff(moment(startDate))).asDays() >= 7 ? (
          <TextField
            id="email"
            style={{ width: 270, marginLeft: 25, marginBottom: 10 }}
            label="Report will be sent here"
            variant="standard"
			onChange={e => {
				debugger;
				setEmail(e.target.value)
			}}
            value={email}
          />
        ) : null}
      </div>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Store ID</TableCell>
              <TableCell align="left">Driver</TableCell>
              <TableCell align="left">Order ID</TableCell>
              <TableCell align="left">Type</TableCell>
              <TableCell align="left">Click Count</TableCell>
              <TableCell align="left">OTD</TableCell>
              <TableCell align="left">ATD</TableCell>
              <TableCell align="left">Order Creation</TableCell>
              <TableCell align="left">Claimed At</TableCell>
              <TableCell align="left">Start Delivery Time</TableCell>
              <TableCell align="left">Delivered Time</TableCell>
              <TableCell align="left">Group Code</TableCell>
              <TableCell align="left">Rating</TableCell>
              <TableCell align="left">Remarks</TableCell>
              <TableCell align="left">Photo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.rows.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={13}>
                  <span className={classes.noResults}>No results found</span>
                </TableCell>
              </TableRow>
            )}
            {data?.rows.map((row) => {
              return (
                <TableRow key={row.orderId} style={{ verticalAlign: "top" }}>
                  <TableCell align="left">{row.store}</TableCell>
                  <TableCell align="left">{row.rider}</TableCell>
                  <TableCell align="left">{row.orderId}</TableCell>
                  <TableCell align="left">{row.type}</TableCell>
                  <TableCell align="left">{row.linkClickCount}</TableCell>
                  <TableCell align="left">{row.otd}</TableCell>
                  <TableCell align="left">{row.atd}</TableCell>
                  <TableCell align="left">{row.dateCreated}</TableCell>
                  <TableCell align="left">{row.claimedAt}</TableCell>
                  <TableCell align="left">{row.deliveryStartedAt}</TableCell>
                  <TableCell align="left">{row.deliveredAt}</TableCell>
                  <TableCell align="left">{row.groupCode}</TableCell>
                  <TableCell align="left">{renderRating(row.rating)}</TableCell>
                  <TableCell align="left">
                    {row.rating > 0 && (
                      <a
                        href="#view-remarks"
                        onClick={(e) => {
                          e.preventDefault();
                          setRemarks(row.remarks);
                          setOpen(true);
                        }}
                      >
                        View Remarks
                      </a>
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {row.photo && (
                      <Link href={row.photo} target="_blank">
                        View
                      </Link>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box my={2} display="flex" justifyContent="center">
        <Pagination
          className={classes.pagination}
          count={data ? data.totalPages : 0}
          page={page}
          shape="rounded"
          onChange={handlePaginationChange}
        />
      </Box>
      <Modal
        className={classes.modal}
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2>Remarks</h2>
            {remarks.trim() !== "" ? remarks : <>No Remarks</>}
          </div>
        </Fade>
      </Modal>
    </Loader>
  );
}

export default MainLayout(Transactions);
